import React, { Component } from 'react'

export class QuizBullet extends Component {
    state = {
        active: false,
        id: undefined
    }

    componentWillMount() {
        this.props.handleChange('id', this.props.id)
        if (this.props.step === this.props.id) {
            this.setState({
                active: true
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.step === nextProps.id) {
            this.setState({
                active: true
            })
        }
        else {
            this.setState({
                active: false
            })
        }
    }

    render() {
        const backgroundColorPencil = {
            backgroundColor: this.props.colour
        }

        return (
            <div style={backgroundColorPencil} className={this.state.active ? "bar-item active" : "bar-item"}>
                <img alt="icon" className="bar-item-image" src={(this.props.icon)} />
                <p className={this.state.active ? "categoryActive" : "categoryDisabled"}>{this.props.categoryName}</p>
                <div className="bar-item-wrapper">
                    <p>{this.props.categoryName}</p>
                </div>
            </div>
        )
    }
}

export default QuizBullet
